import { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { setCountry } from "../../../redux/features/user/user-slice";
import { ECountry } from "../../../shared/oversight-core/enums/country";
import AppSelect, {
  Option,
} from "../../../shared/oversight-core/ui-elements/app-select/app-select";
import AppButton from "../../../shared/oversight-core/ui-elements/buttons/app-button/app-button";
import CountryFlag from "../../../shared/oversight-core/ui-elements/country-flag/country-flag";
import ModalContainer, {
  ModelContainerProps,
} from "../../../shared/oversight-core/ui-elements/modal-container/modal-container";
import translate from "../../../shared/oversight-core/utils/translate";

interface IProps extends ModelContainerProps {
  show: boolean;
}

const countryList: Option[] = [
  {
    value: ECountry.KE,
    label: (
      <CountryFlag
        countryCode={ECountry.KE}
        countryName={translate(ECountry.KE)}
      />
    ),
  },
  {
    value: ECountry.UG,
    label: (
      <CountryFlag
        countryCode={ECountry.UG}
        countryName={translate(ECountry.UG)}
      />
    ),
  },
  {
    value: ECountry.TZ,
    label: (
      <CountryFlag
        countryCode={ECountry.TZ}
        countryName={translate(ECountry.TZ)}
      />
    ),
  },
];

const CountrySelectModal = (props: IProps) => {
  const { show, ...rest } = props;

  const [selectedCountry, setSelectedCountry] = useState<Option>({
    ...countryList[0],
  });

  const dispatch = useDispatch();

  return (
    <ModalContainer
      title=""
      {...rest}
      show={show}
      size="modal-md"
      isButtonsVisible={false}
    >
      <>
        <Row>
          <Col className="text-center">
            <Row>
              <Col className="modal-title font-weight-500 font-size-32">
                Select Your Country
              </Col>
            </Row>
            <Row>
              <Col className="text-advance-description font-weight-400 font-size-16">
                Select your country of installation.
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="my-5 py-3">
          <Col>
            <AppSelect
              options={countryList}
              selectedValue={selectedCountry}
              onChangeOption={(selectOption) =>
                setSelectedCountry(selectOption)
              }
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <AppButton
              text="Select Country"
              className="font-weight-600"
              onClick={() => {
                dispatch(setCountry(selectedCountry.value as ECountry));
                props.onClose?.();
              }}
            />
          </Col>
        </Row>
      </>
    </ModalContainer>
  );
};

export default CountrySelectModal;
